import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { membershipAlertErrorSelector } from '@hero/redux-data/backoffice/membershipAlert/selectors';
import { useNotifications } from '../../context/notification';
const useMembershipAlertSaveFailAlert = () => {
    const { error, errorMessage } = useSelector(membershipAlertErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: errorMessage || 'Error saving changes.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, errorMessage]);
};
export default useMembershipAlertSaveFailAlert;
